import React, { useMemo, useRef } from 'react'
import UserMenu from 'components/Drawer/subcomponents/DrawerFooter/subcomponents/UserMenu'
import TicketsCounter from 'components/Header/subcomponents/TicketsCounter'
import Button from 'gu-ui-kit/Button'
import Grid from 'gu-ui-kit/Grid/Container'
import Icon from 'gu-ui-kit/Icon'
import Tooltip from 'gu-ui-kit/Tooltip'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'
import styles from 'components/Drawer/drawer.module.scss'
import { useSelector } from 'react-redux'
import { selectAppUser } from 'modules/App/store/selectors'
import { Link } from 'react-router-dom'
import FaqMenu from 'components/Drawer/subcomponents/DrawerFooter/subcomponents/FaqMenu'
import DrawerFooterAnimatedIcon from 'components/Drawer/subcomponents/DrawerFooter/subcomponents/DrawerFooterAnimatedIcon'
import { useTranslation } from 'react-i18next'

const DrawerFooter = ({ collapse }) => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()

  const { is_email_confirmed } = useSelector(selectAppUser)

  const isEmailConfirmed = useMemo(
    () => (typeof is_email_confirmed === 'boolean' ? is_email_confirmed : null),
    [is_email_confirmed],
  )

  const footerAnchorRef = useRef(null)

  const settingsButton = (
    <Button
      grey
      noLabel
      className={styles['drawer-footer__button']}
      color={'Interface-Eighth'}
      component={Link}
      size={'s'}
      startIcon={<DrawerFooterAnimatedIcon name={'settings'} />}
      title={collapse ? undefined : t('common::user_menu.settings')}
      to={pathGen(ROUTES.USER_SETTINGS)}
      variant={'ghost'}
    />
  )

  return (
    <div
      ref={footerAnchorRef}
      data-drawer-footer-anchor
      className={styles['drawer-inner__grid_bottom']}
    >
      <Grid
        flexDirection={collapse ? 'column' : 'row'}
        flexJustify={'space-between'}
        gap={8}
        style={{ width: '100%' }}
        wrap={false}
      >
        <UserMenu
          className={styles['drawer-footer__button']}
          collapse={collapse}
          footerAnchorRef={footerAnchorRef}
        />
        <div className={styles['drawer-footer__button-wrap']}>
          <TicketsCounter
            className={styles['drawer-footer__button']}
            collapse={collapse}
          />
        </div>

        <FaqMenu
          className={styles['drawer-footer__button']}
          collapse={collapse}
          footerAnchorRef={footerAnchorRef}
        />

        <div className={styles['drawer-footer__button-wrap']}>
          {collapse ? (
            <Tooltip
              placement={'right'}
              title={t('common::user_menu.settings')}
            >
              {settingsButton}
            </Tooltip>
          ) : (
            settingsButton
          )}
          {isEmailConfirmed === false && (
            <Icon
              className={'notify-icon'}
              color={'Accent-Error-Primary'}
              name={'status warning2'}
              size={'s'}
            />
          )}
        </div>
      </Grid>
    </div>
  )
}

export default DrawerFooter

DrawerFooter.propTypes = {
  collapse: PropTypes.bool,
}
